import axios from './axiosInstances/privateAxiosInstance';

const API_URL = '/qs/account/user/getappparam';

export namespace AppParams {
  export type Name =
    | 'enable_YMME_searching'
    | 'allow_all_autoparts_script_types'
    | 'enable_search_by_category'
    | 'max_days_for_results_view'
    | 'read_only_benchmark'
    | 'read_only_match'
    | 'anon_admin'
    | 'priv_deactivate_script'
    | 'ra_data_cleanup'
    | 'ra_product_cleanup'
    | 'ra_shallow_cleanup'
    | 'ra_spider_cleanup'
    | 'ra_client_management'
    | 'ra_match_attribute_management'
    | 'ra_site_management'
    | 'error_monitoring'
    | 'ra_data_editor'
    | 'ra_diagnostic'
    | 'streaming_status'
    | 'system_status';

  export type Value = boolean | number;

  export type Item<K extends Name, V extends Value> = {
    name: K;
    value: V;
  };

  export type Response<K extends Name, V extends Value> = {
    AppParams: Item<K, V>[] | null;
  };
}

export type GetApplicationParams = typeof getApplicationParams;

export const getApplicationParams = async <K extends AppParams.Name, V extends AppParams.Value>(
  appId: string,
  appParams: readonly K[],
  extraParams?: Record<string, string>
): Promise<AppParams.Item<K, V>[]> => {
  const response: AppParams.Response<K, V> | null = await axios.get(API_URL, {
    params: {
      appId,
      appParams: appParams.join(),
      ...extraParams,
    },
  });
  return response?.AppParams ?? [];
};